import { isRebuyEmbedded } from './rebuy-detection.js'

const useLegacySearch = () => document.documentElement.getAttribute('data-legacy-search') === 'true'

const openLegacySearch = () => {
    document.body.setAttribute('data-search-open', 'true')
    const searchInput = document.body.querySelector('input.searchOverlay__input')
    if (searchInput) searchInput.focus()
}

const closeLegacySearch = () => {
    document.body.removeAttribute('data-search-open')
    const openBtn = document.body.querySelector('button[data-open-search]')
    if (openBtn) openBtn.focus()
}

const openRebuySearch = (event) => {
    const quickView = window.Rebuy?.SmartSearch?.quickView?.view
    if (typeof quickView?.openQuickView === 'function') {
        quickView.openQuickView(event)
        return true
    }
    return false
}

document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('button[data-open-search]')
    const closeBtn = e.target.closest('[data-close-search]')

    if (openBtn) {
        e.preventDefault()

        if (useLegacySearch()) {
            openLegacySearch()
            return
        }

        if (isRebuyEmbedded()) {
            if (!openRebuySearch(e)) {
                document.addEventListener('rebuy:smartsearch.quickview.ready', () => {
                    openRebuySearch(e)
                }, { once: true })
            }
        }
    }

    if (closeBtn && useLegacySearch()) {
        e.preventDefault()
        closeLegacySearch()
    }
})

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && useLegacySearch() && document.body.getAttribute('data-search-open') === 'true') {
        closeLegacySearch()
    }
})
